import React, { Fragment } from 'react';

import LoadingIndicator from '@dashboard/components/loading/LoadingIndicator';
import { useVerifiedEmailAddressesQuery } from '@dashboard/generated/wp/platform';
import { Divider, List, ListItem, ListItemText, Typography } from '@mui/material';

import EditVerifiedEmailAddressDialog from './EditVerifiedEmailAddressDialog';

export default function SectionBody(): JsxNode {
  const { data } = useVerifiedEmailAddressesQuery();
  const res = data?.VerifiedEmailAddresses;

  if (res === undefined) {
    return <LoadingIndicator />;
  }

  const { count, nodes } = res;
  if (count === 0) {
    return <Typography color="text.secondary">An approved sender is required to send live emails.</Typography>;
  }

  return (
    <List dense={false} sx={{ pt: 0 }}>
      {nodes.map((k) => (
        <Fragment key={k.id}>
          <ListItem disableGutters>
            <ListItemText sx={{ flexBasis: '35%', flexGrow: 0 }}>
              <Typography noWrap>{k.name}</Typography>
            </ListItemText>
            <ListItemText>
              <Typography color="text.secondary">{k.emailAddress}</Typography>
            </ListItemText>
            <EditVerifiedEmailAddressDialog model={k} />
          </ListItem>
          <Divider />
        </Fragment>
      ))}
    </List>
  );
}
